"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeFromObject = exports.isUndefined = void 0;

var removeFromObject = function removeFromObject(elementsToRemove, objectForRemoval) {
  var elementsToLoop = typeof elementsToRemove === 'string' ? [elementsToRemove] : elementsToRemove;
  var objectWithRemoval = Object.assign({}, objectForRemoval);
  elementsToLoop.forEach(function (key) {
    return delete objectWithRemoval[key];
  });
  return objectWithRemoval;
};

exports.removeFromObject = removeFromObject;

var isUndefined = function isUndefined(prop) {
  return typeof prop === 'undefined';
};

exports.isUndefined = isUndefined;